import axios from 'axios';
axios.defaults.withCredentials = true;

const authProvider = {
    login: async ({ username, password }) =>  {
		const csrfRes = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/sanctum/csrf-cookie`);
		const loginRes = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/login`, {email: username, password});

		if(loginRes.data.result !== true) {
			throw new Error();
		}
        /*const request = new Request(`${process.env.BACKEND_URL}/login`, {
            method: 'POST',
            body: JSON.stringify({ username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });*/
    },
	checkError: ({ message, status, body }) => status != 401 ? Promise.resolve() : Promise.reject({ redirectTo: '/login', message: false }),
    checkAuth: () => new Promise((resolve, reject) => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/user`).then(resolve, () => reject({ redirectTo: '/login', message: false }));
    }),
	logout: () => axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/logout`).then(res => Promise.resolve(res.result)),
    getIdentity: () => async () => {
        const userRes = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/user`);
        return userRes;
    },
    getPermissions: () => {
        // Required for the authentication to work
        return Promise.resolve();
    },
};

export default authProvider;